<template>
  <section>
    <div class="border-t border-solid border-gray-400 bg-gray-100">
      <div class="container-wrap tablet:flex">
        <div
          class="border-b border-solid border-gray-400 py-5 tablet:w-1/2 tablet:border-b-0 tablet:border-r tablet:pr-5 desktop:py-12 desktop:pr-12"
        >
          <h2 class="mb-5 text-2xl font-bold desktop:text-3xl">
            {{ t('title-1') }}
          </h2>
          <p class="mb-5 min-h-12">
            {{ t('description-1') }}
          </p>
          <TheButton
            :id="isCN ? 'tracking_contactUs' : undefined"
            :to="`/${locale}/marketplace/help/contact-us`"
            :title="t('item-button-1')"
            class="w-full tablet:w-[180px]"
          >
            <span class="text-sm">
              {{ t('item-button-1') }}
            </span>
          </TheButton>
        </div>
        <div class="py-5 tablet:w-1/2 tablet:pl-5 desktop:py-12 desktop:pl-12">
          <h2 class="mb-5 text-2xl font-bold desktop:text-3xl">
            {{ t('title-2') }}
          </h2>
          <p class="mb-5 min-h-12">
            {{ t('description-2') }}
          </p>
          <TheButton
            :id="isCN ? 'tracking_subscribe' : undefined"
            :to="subscribeUrl"
            :title="t('item-button-2')"
            class="w-full tablet:w-[180px]"
          >
            <span class="text-sm">{{ t('item-button-2') }}</span>
          </TheButton>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  const { t, locale } = useI18n({ useScope: 'local' });
  const { isCN } = useLanguage();

  const subscribeUrl = computed((): string => {
    return isCN.value
      ? 'https://mkt.advantech.com.cn/contentCenter/ContentCenterInfo/Z84wvR/weixin'
      : 'https://campaign-wise-iot.advantech.com/newlettersubscribepage';
  });
</script>

<i18n lang="json">
{
  "en-int": {
    "title-1": "Reach Out Now!",
    "description-1": "We're here to help you get started.",
    "item-button-1": "Contact Us",
    "title-2": "Stay Updated!",
    "description-2": "Subscribe to our newsletter and get the latest AIoT insights.",
    "item-button-2": "Subscribe Now"
  },
  "en-jp": {
    "title-1": "Reach Out Now!",
    "description-1": "We're here to help you get started.",
    "item-button-1": "Contact Us",
    "title-2": "Stay Updated!",
    "description-2": "Subscribe to our newsletter and get the latest AIoT insights.",
    "item-button-2": "Subscribe Now"
  },
  "en-tw": {
    "title-1": "Reach Out Now!",
    "description-1": "We're here to help you get started.",
    "item-button-1": "Contact Us",
    "title-2": "Stay Updated!",
    "description-2": "Subscribe to our newsletter and get the latest AIoT insights.",
    "item-button-2": "Subscribe Now"
  },
  "en-kr": {
    "title-1": "Reach Out Now!",
    "description-1": "We're here to help you get started.",
    "item-button-1": "Contact Us",
    "title-2": "Stay Updated!",
    "description-2": "Subscribe to our newsletter and get the latest AIoT insights.",
    "item-button-2": "Subscribe Now"
  },
  "en-americas": {
    "title-1": "Reach Out Now!",
    "description-1": "We're here to help you get started.",
    "item-button-1": "Contact Us",
    "title-2": "Stay Updated!",
    "description-2": "Subscribe to our newsletter and get the latest AIoT insights.",
    "item-button-2": "Subscribe Now"
  },
  "en-asia-pacific": {
    "title-1": "Reach Out Now!",
    "description-1": "We're here to help you get started.",
    "item-button-1": "Contact Us",
    "title-2": "Stay Updated!",
    "description-2": "Subscribe to our newsletter and get the latest AIoT insights.",
    "item-button-2": "Subscribe Now"
  },
  "en-emea": {
    "title-1": "Reach Out Now!",
    "description-1": "We're here to help you get started.",
    "item-button-1": "Contact Us",
    "title-2": "Stay Updated!",
    "description-2": "Subscribe to our newsletter and get the latest AIoT insights.",
    "item-button-2": "Subscribe Now"
  },
  "ja-jp": {
    "title-1": "今すぐお問い合わせください！",
    "description-1": "私たちはいつでもスタートをサポートします。",
    "item-button-1": "お問い合わせ",
    "title-2": "最新情報を入手しましょう！",
    "description-2": "ニュースレターに登録して、最新の AI x IoT インサイトを手に入れましょう。",
    "item-button-2": "今すぐ購読"
  },
  "zh-cn": {
    "title-1": "立即联系我们！",
    "description-1": "我们随时为您提供帮助，助您启动。",
    "item-button-1": "联系我们",
    "title-2": "掌握更多关于研华工业云资讯",
    "description-2": "订阅我们的通讯，获取最新的 AIoT 洞见。",
    "item-button-2": "立即订阅"
  },
  "zh-tw": {
    "title-1": "立即聯繫我們！",
    "description-1": "我們隨時為您提供幫助，協助您啟動。",
    "item-button-1": "聯繫我們",
    "title-2": "掌握更多關於 WISE 資訊",
    "description-2": "訂閱我們的電子報，獲取最新的 AIoT 洞見。",
    "item-button-2": "立即訂閱"
  }
}
</i18n>
